module.exports = __webpack_public_path__ + "img/game4.3.33a1808a.png";